export default __webpack_public_path__ + "static/media/postcode-api.d0d73fff.svg";